export const ADD_REGION = 'ADD_REGION';
export const ADD_PRICE_RANGE = 'ADD_PRICE_RANGE';
export const ADD_FLAVOUR_MOOD = 'ADD_FLAVOUR_MOOD';
export const CLEAR = 'CLEAR';
